@if (hasChanged && SelectedItem && isCompanyOrManager()) {
  <p class="not-saved-block">Изменения не сохранены</p>
}

@if (IsSelected) {
  <div class="input-wrap" (click)="$event.stopPropagation()">
    <div class="input-wrap">
      <label>Выберите партнера</label>
      @if (PartnersList.length ) {
        <ng-select
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [placeholder]="'Не выбрано'"
          [notFoundText]="'Не найдено'"
          [searchable]="false"
          [clearable]="false"
          [appendTo]="'body'"
          [items]="PartnersList"
          [(ngModel)]="SelectedItem"
          >
        </ng-select>
      }
    </div>
    <div class="buttons">
      <div class="button" (click)="changePartner()">Сохранить</div>
    </div>
  </div>
}

@if (!IsSelected) {
  <div #partner class="input-wrap">
    @if (ItemData) {
      <div  class="partner-wrap">
        @if (PartnerData) {
          <div >
            @if (isCompanyOrManager() && !PartnerData.shown) {
              <div>
                <p class="not-saved-block left">Данный партнер скрыт от учеников!</p>
              </div>
            }
            <!-- {{widthBlock}} -->
            <!-- {{PartnerData | json}} -->
            <div class="partner">
              <app-partners-item
                [id]="PartnerData.id"
                [name]="PartnerData.name"
                [bonus]="PartnerData.bonuses"
                [description]="PartnerData.description"
                [contacts]="PartnerData.contactInfo"
                [id]="PartnerData.id"
                [isSystem]="PartnerData.isSystem"
                [isBlock]="widthBlock && widthBlock < 440 ? true : false"
                [contacts]="ContactInfo"
                [ContactLoading]="ContactLoading"
                [viewMode]="true"
                (getContact)="GetContact($event)"
                >
              </app-partners-item>
            </div>
          </div>
        }
        @if (PartnerNotFounded) {
          <div>
            <p>Партнер не найден</p>
          </div>
        }
      </div>
    }
    @if (!ItemData) {
      <div class="no-partner">
        <p class="f-text" style="text-align:center">Нет партнера</p>
      </div>
    }
  </div>
}
